module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-animate/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 1330
 ** module chunks = 3
 **/